import { urlBuilder } from './builder';

export default urlBuilder(() => '/messages/');
